import Aura from '@primevue/themes/aura';
import PrimeVue from 'primevue/config';
import 'vite/modulepreload-polyfill';
import { defineCustomElement } from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import BookingPaymentForm from './components/BookingForm/BookingPaymentForm.ce.vue';
import ConfirmBookingForm from './components/BookingForm/ConfirmBookingForm.ce.vue';
import StartBookingForm from './components/BookingForm/StartBookingForm.vue';
import StartBundledBookingForm from './components/BookingForm/StartBundledBookingForm.vue';
import EnquiryFormCe from './components/EnquiryForm/EnquiryForm.ce.vue';
import FilteredGames from './components/FilteredGames.ce.vue';
import GameTileList from './components/GameTileList.ce.vue';
import HeaderImageSlider from './components/HeaderImageSlider.ce.vue';
import ImageSliderList from './components/ImageSliderList.ce.vue';
import LandingPageTileListCe from './components/LandingPageTileList.ce.vue';
import NewsArticleTileList from './components/NewsArticleTileList.ce.vue';
import NewsHubFilters from './components/NewsHub/NewsHubFilters.vue';
import NewsletterSignupFormCe from './components/NewsletterSignupForm/NewsletterSignupForm.ce.vue';
import PxFusionFormCe from './components/PxFusionForm/PxFusionForm.ce.vue';
import SiteOfflineBypassFormCe from './components/SiteOfflineBypassForm/SiteOfflineBypassForm.ce.vue';
import TestimonialList from './components/TestimonialList.ce.vue';
import VideoItem from './components/VideoItem.ce.vue';

const recaptchaSiteKey = '6LdhqOgqAAAAACqaUU8TNAz4QOlb7y5lU4fm_ksp';

customElements.define(
	'landing-page-tile-list',
	defineCustomElement(LandingPageTileListCe, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
		},
	})
);
customElements.define(
	'testimonial-list',
	defineCustomElement(TestimonialList, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
		},
	})
);
customElements.define(
	'image-slider-list',
	defineCustomElement(ImageSliderList, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
		},
	})
);

customElements.define(
	'enquiry-form',
	defineCustomElement(EnquiryFormCe, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
			app.use(VueReCaptcha, { siteKey: recaptchaSiteKey, loaderOptions: {} });
		},
	})
);

customElements.define(
	'newsletter-signup-form',
	defineCustomElement(NewsletterSignupFormCe, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
			app.use(VueReCaptcha, { siteKey: recaptchaSiteKey, loaderOptions: {} });
		},
	})
);

customElements.define(
	'game-tile-list',
	defineCustomElement(GameTileList, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
		},
	})
);

customElements.define(
	'start-booking-form',
	defineCustomElement(StartBookingForm, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
		},
	})
);

customElements.define(
	'start-bundled-booking-form',
	defineCustomElement(StartBundledBookingForm, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
		},
	})
);

customElements.define(
	'confirm-booking-form',
	defineCustomElement(ConfirmBookingForm, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
		},
	})
);

customElements.define(
	'booking-payment-form',
	defineCustomElement(BookingPaymentForm, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
		},
	})
);

customElements.define(
	'header-image-slider',
	defineCustomElement(HeaderImageSlider, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
		},
	})
);

customElements.define(
	'filtered-games',
	defineCustomElement(FilteredGames, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
		},
	})
);

customElements.define(
	'video-player-item',
	defineCustomElement(VideoItem, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
		},
	})
);

customElements.define(
	'news-article-tile-list',
	defineCustomElement(NewsArticleTileList, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
		},
	})
);

customElements.define(
	'news-hub-filters',
	defineCustomElement(NewsHubFilters, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
		},
	})
);

customElements.define(
	'site-offline-bypass-form',
	defineCustomElement(SiteOfflineBypassFormCe, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
		},
	})
);

customElements.define(
	'pxfusion-form',
	defineCustomElement(PxFusionFormCe, {
		shadowRoot: false,
		configureApp(app) {
			app.use(PrimeVue, { theme: { preset: Aura } });
		},
	})
);
